import type { PanelProps } from "../panel-props"

import { useToggleSettings } from "../../../hooks/use-toggle-settings"
import { useSettings } from "../../../modules/settings"
import { ToggleButton } from "../../toggle-button"
import { SharedSettings } from "../shared-settings.tsx"

export function SpeakAppsSettings(input: PanelProps) {
  const { appSettings, setAppSettings } = useSettings()

  const { isOn: acceptMicInputOnInitOn, toggle: toggleAcceptMicInputOnInit } =
    useToggleSettings({
      currentValue: appSettings.shared.acceptMicInputOnInit,
      setValue: newValue=> {
        setAppSettings("acceptMicInputOnInit", newValue, "shared")
      },
    })

  const { isOn: speakWhenHandsFreeOn, toggle: toggleSpeakWhenHandsFree } =
    useToggleSettings({
      currentValue: appSettings.shared.speakWhenHandsFree,
      setValue: newValue=> {
        setAppSettings("speakWhenHandsFree", newValue, "shared")
      },
    })

  const { isOn: goToNextOnSuccessOn, toggle: toggleGoToNextOnSuccess } =
    useToggleSettings({
      currentValue: appSettings.shared.goToNextOnSuccess,
      setValue: newValue=> {
        setAppSettings("goToNextOnSuccess", newValue, "shared")
      },
    })

  return (
    <SharedSettings closeSidebar={input.closeSidebar}>
      <section className="sidebar__section">
        <h3 className="sidebar__section-title">Input</h3>
        <ToggleButton
          checked={acceptMicInputOnInitOn}
          label="Mic is on initially"
          onChange={toggleAcceptMicInputOnInit}
        />
      </section>

      <div className="sidebar__separator" role="separator" />

      <section className="sidebar__section">
        <h3 className="sidebar__section-title">Handsfree</h3>
        <ToggleButton
          checked={goToNextOnSuccessOn}
          label="Handsfree mode(Go to next automatically)"
          onChange={toggleGoToNextOnSuccess}
        />
        <ToggleButton
          checked={speakWhenHandsFreeOn}
          label="Handsfree mode(speak the text automatically)"
          onChange={toggleSpeakWhenHandsFree}
        />
      </section>
    </SharedSettings>
  )
}
